import Board from './board.js';

export default class TTT {
  constructor() {
    this._board = new Board();
    this._turn = 'X';
    this._moves = [];
    this._lastMove = null;
    this._representations = [];
    this._representations.push(this._board.getBoardCopy());
  }

  makeMove(x, y) {
    if (this._board.makeMove(x, y, this._turn)) {
      this._turn = (this._turn == "X") ? ("O") : ("X");
      this._moves.push([x, y]);
      this._lastMove = [x, y];
      this._representations.push(this._board.getBoardCopy());
      return true;
    }
    return false;
  }

  getResult() {
    return this._board.getResult();
  }

  getSquare(x, y) {
    return this._board.getSquare(x, y);
  }

  printBoard() {
    this._board.printBoard();
  }

  getNextTurn() {
    return this._turn;
  }

  getRepresentations() {
    return this._representations;
  }

  getLastMove() {
    return this._lastMove;
  }

  // Stuff below returns null, as it is only relevant for UTTT, not TTT
  // I am implementing this here so that I have a uniform interface for both TTT nd UTTT, makes coding easy
  // Maybe the proper way to do this is defining a separate interface and implementing it, but not sure if thats possible in javascript.
  getBigRepresentations() {
    return null;
  }
  isAllAllowed() {
    return null;
  }
}